/* eslint-disable jira/naming/disallow-filenames */
import queryString from 'query-string';
import type { RouteContext } from '@atlassian/react-resource-router';

type GetBoardIdArgs = {
	location: RouteContext['location'];
	match: RouteContext['match'];
};

export const getBoardId = ({ location, match }: GetBoardIdArgs): string => {
	if (match && match.params.boardId) {
		return match.params.boardId;
	}
	const { rapidView } = queryString.parse(location.search);
	return rapidView;
};
